import React from 'react'
import MainLayout from '../../Layouts/Mainlayout'
import EmailAPIClientList from './ClientList'

function EmailAPIClients(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <EmailAPIClientList />
      </MainLayout>
    </div>
  )
}

export default EmailAPIClients